import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    home: "Accueil",
    listings: "Logements",
    contact: "Contact",
    partnership: "Partenariat",
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    admin: "Administration",
    
    // Hero
    heroTitle: "Trouvez votre logement idéal en Afrique",
    heroSubtitle: "Appartements meublés, chambres et hôtels au Cameroun et bientôt dans toute l'Afrique",
    searchPlaceholder: "Où souhaitez-vous séjourner ?",
    aiSearchPlaceholder: "Décrivez le logement de vos rêves...",
    search: "Rechercher",
    
    // Filters
    allTypes: "Tous les types",
    apartment: "Appartement",
    room: "Chambre",
    hotel: "Hôtel",
    studio: "Studio",
    country: "Pays",
    city: "Ville",
    neighborhood: "Quartier",
    priceRange: "Budget",
    minPrice: "Prix min",
    maxPrice: "Prix max",
    amenities: "Équipements",
    wifi: "WiFi",
    ac: "Climatisation",
    parking: "Parking",
    furnished: "Meublé",
    
    // Listing
    perNight: "/ nuit",
    viewDetails: "Voir détails",
    contactWhatsApp: "Contacter via WhatsApp",
    guests: "voyageurs",
    description: "Description",
    equipments: "Équipements",
    rules: "Règles",
    location: "Localisation",
    
    // Auth
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    name: "Nom complet",
    phone: "Téléphone",
    loginTitle: "Connexion",
    registerTitle: "Créer un compte",
    googleLogin: "Continuer avec Google",
    orContinueWith: "ou continuer avec",
    alreadyAccount: "Déjà un compte ?",
    noAccount: "Pas de compte ?",
    ownerAccount: "Je suis propriétaire",
    
    // Dashboard
    myListings: "Mes annonces",
    addListing: "Ajouter une annonce",
    editListing: "Modifier",
    deleteListing: "Supprimer",
    active: "Active",
    inactive: "Inactive",
    views: "vues",
    
    // Admin
    statistics: "Statistiques",
    manageListings: "Gérer les annonces",
    manageUsers: "Gérer les utilisateurs",
    manageLocations: "Gérer les lieux",
    totalListings: "Total annonces",
    activeListings: "Annonces actives",
    totalUsers: "Total utilisateurs",
    featuredListings: "Annonces en vedette",
    feature: "Mettre en avant",
    unfeature: "Retirer la mise en avant",
    verify: "Vérifier",
    
    // Contact
    contactTitle: "Contactez-nous",
    contactSubtitle: "Une question ? Un problème ? Nous sommes là pour vous aider.",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer",
    
    // Partnership
    partnershipTitle: "Devenez partenaire",
    partnershipSubtitle: "Rejoignez l'aventure Roomia.net et développez votre activité en Afrique.",
    companyName: "Nom de l'entreprise",
    partnershipType: "Type de partenariat",
    
    // Legal
    legalTitle: "Mentions légales",
    cguTitle: "Conditions Générales d'Utilisation",
    privacyTitle: "Politique de confidentialité",
    
    // Footer
    aboutUs: "À propos",
    aboutText: "Roomia.net est la première plateforme de logements meublés en Afrique, conçue pour répondre aux besoins des étudiants, professionnels et voyageurs.",
    quickLinks: "Liens rapides",
    legal: "Mentions légales",
    followUs: "Suivez-nous",
    copyright: "© 2026 Roomia.net. Tous droits réservés.",
    
    // Messages
    listingCreated: "Annonce créée avec succès",
    listingUpdated: "Annonce mise à jour",
    listingDeleted: "Annonce supprimée",
    messageSent: "Message envoyé",
    error: "Une erreur est survenue",
    
    // Featured
    featuredListings: "Logements en vedette",
    viewAll: "Voir tout",
    
    // Cities
    popularCities: "Villes populaires",
  },
  en: {
    // Navigation
    home: "Home",
    listings: "Listings",
    contact: "Contact",
    partnership: "Partnership",
    login: "Login",
    register: "Register",
    logout: "Logout",
    dashboard: "Dashboard",
    admin: "Admin",
    
    // Hero
    heroTitle: "Find your ideal accommodation in Africa",
    heroSubtitle: "Furnished apartments, rooms and hotels in Cameroon and soon across Africa",
    searchPlaceholder: "Where would you like to stay?",
    aiSearchPlaceholder: "Describe your dream accommodation...",
    search: "Search",
    
    // Filters
    allTypes: "All types",
    apartment: "Apartment",
    room: "Room",
    hotel: "Hotel",
    studio: "Studio",
    country: "Country",
    city: "City",
    neighborhood: "Neighborhood",
    priceRange: "Budget",
    minPrice: "Min price",
    maxPrice: "Max price",
    amenities: "Amenities",
    wifi: "WiFi",
    ac: "Air conditioning",
    parking: "Parking",
    furnished: "Furnished",
    
    // Listing
    perNight: "/ night",
    viewDetails: "View details",
    contactWhatsApp: "Contact via WhatsApp",
    guests: "guests",
    description: "Description",
    equipments: "Amenities",
    rules: "Rules",
    location: "Location",
    
    // Auth
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    name: "Full name",
    phone: "Phone",
    loginTitle: "Login",
    registerTitle: "Create account",
    googleLogin: "Continue with Google",
    orContinueWith: "or continue with",
    alreadyAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    ownerAccount: "I am a property owner",
    
    // Dashboard
    myListings: "My listings",
    addListing: "Add listing",
    editListing: "Edit",
    deleteListing: "Delete",
    active: "Active",
    inactive: "Inactive",
    views: "views",
    
    // Admin
    statistics: "Statistics",
    manageListings: "Manage listings",
    manageUsers: "Manage users",
    manageLocations: "Manage locations",
    totalListings: "Total listings",
    activeListings: "Active listings",
    totalUsers: "Total users",
    featuredListings: "Featured listings",
    feature: "Feature",
    unfeature: "Unfeature",
    verify: "Verify",
    
    // Contact
    contactTitle: "Contact us",
    contactSubtitle: "Have a question? A problem? We're here to help.",
    subject: "Subject",
    message: "Message",
    send: "Send",
    
    // Partnership
    partnershipTitle: "Become a partner",
    partnershipSubtitle: "Join the Roomia.net adventure and grow your business in Africa.",
    companyName: "Company name",
    partnershipType: "Partnership type",
    
    // Legal
    legalTitle: "Legal notice",
    cguTitle: "Terms of Service",
    privacyTitle: "Privacy Policy",
    
    // Footer
    aboutUs: "About us",
    aboutText: "Roomia.net is the first furnished accommodation platform in Africa, designed for students, professionals and travelers.",
    quickLinks: "Quick links",
    legal: "Legal",
    followUs: "Follow us",
    copyright: "© 2026 Roomia.net. All rights reserved.",
    
    // Messages
    listingCreated: "Listing created successfully",
    listingUpdated: "Listing updated",
    listingDeleted: "Listing deleted",
    messageSent: "Message sent",
    error: "An error occurred",
    
    // Featured
    featuredListings: "Featured listings",
    viewAll: "View all",
    
    // Cities
    popularCities: "Popular cities",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('roomia_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('roomia_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
